




























































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import { validateCPF, validateEmail, onlyNumber, getUfs } from '@/utils/common'

@Component
export default class ComponentModalBackofficeAlterarMedico extends Vue {
  @Prop({ required: true, default: false }) readonly: boolean

  loadAlterarMedico: boolean = false
  loadAlterarTipoMedicoEOrdenacao: boolean = false
  ufs: any[] = [...getUfs()]

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get cbos() {
    return this.getBackofficeCadastroMedicoStore.cbos
  }

  get loadingAlterarMedico() {
    return this.loadAlterarMedico
  }

  set loadingAlterarMedico(value: boolean) {
    this.loadAlterarMedico = value
  }

  get loadingAlterarTipoMedicoEOrdenacao() {
    return this.loadAlterarTipoMedicoEOrdenacao
  }

  set loadingAlterarTipoMedicoEOrdenacao(value: boolean) {
    this.loadAlterarTipoMedicoEOrdenacao = value
  }

  get disableEmailsSecundarios() {
    return this.getBackofficeCadastroMedicoStore.medicoCadastrado.emailsSecundarios.length >= 1
  }

  get showModalAlterarMedico() {
    return this.getBackofficeCadastroMedicoStore.modal.alterarMedico
  }

  set showModalAlterarMedico(value: boolean) {
    this.getBackofficeCadastroMedicoStore.setModal({ name: 'alterarMedico', value })
  }

  loadCpf: boolean = false
  get loadingCpf() { return this.loadCpf }
  set loadingCpf(value: boolean) { this.loadCpf = value }

  cpfErrors: string[] = []

  $refs!: {
    formMedicoCadastrado: any
  }

  formMedicoCadastradoRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    emailPrincipal: [(v: any) => this.validateMainEmailType(v)],
    emailsSecundarios: [(v: any) => this.validateSecondaryEmailType(v)],
    cpf: [(v: any) => this.validateCpfType(v)],
    conselhoTipo: [(v: any) => this.validateConselhoType(v)],
    conselhoNumero: [(v: any) => this.validateConselhoType(v)],
    conselhoUf: [(v: any) => this.validateConselhoType(v)],
    cbos: [],
  }

  removeEspecialidade(id: string) {
    this.getBackofficeCadastroMedicoStore.removeCboFromList(id)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  firstCPF: string = ''

  @Watch('getBackofficeCadastroMedicoStore.medicoCadastrado.cpf')
  async onChangeGetBackofficeCadastroMedicoStoreMedicoCadastradoCpf(value) {
    if (value.length === 11 && value !== this.firstCPF && validateCPF(value)) {
      this.loadingCpf = true
      const request = await this.getCadastroMedicoStore.verificaSeExistePreCadastroMedicoHospital(value)
      if (!request.success) {
        this.loadingCpf = false
        this.cpfErrors = [request.message]
      } else {
        this.cpfErrors = []
      }
      this.loadingCpf = false
    } else {
      this.cpfErrors = []
    }
  }

  validateConselhoType(conselhoValue: any) {
    if (this.readonly) return false
    if (['', null, undefined].includes(conselhoValue)) return 'Campo obrigatório.'
    return false
  }

  validateCpfType(cpfValue: any) {
    if (this.readonly) return false
    if (['', null, undefined].includes(cpfValue)) return 'Campo obrigatório.'
    if (!validateCPF(cpfValue)) return 'CPF inválido.'
    return false
  }

  validateMainEmailType(value) {
    if (this.readonly) return false
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (!validateEmail(value)) return 'E-mail inválido.'
    return false
  }

  validateSecondaryEmailType(value) {
    if (this.readonly) return false
    if (['', null, undefined].includes(value)) return false
    if (!validateEmail(value)) return 'E-mail inválido.'
    return false
  }

  addEmail() {
    this.getBackofficeCadastroMedicoStore.addEmailSecundario('')
  }

  async backofficeAtualizaTipoMedicoEOrdenacao(item: any) {
    this.loadingAlterarTipoMedicoEOrdenacao = true
    const request = await this.getBackofficeCadastroMedicoStore.backofficeAtualizaTipoMedicoEOrdenacao({
      medicoId: item.medicoId,
      hospitalId: item.hospitalId,
      tipomedicoeordenacao: item.tipoMedicoEOrdenacao,
    })

    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar o tipo do médico ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAlterarTipoMedicoEOrdenacao = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Preferência atualizada com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#1976D2',
    })

    this.loadingAlterarTipoMedicoEOrdenacao = false
  }

  async backofficeAlterarMedico() {
    this.loadingAlterarMedico = true

    if (this.$refs.formMedicoCadastrado.validate()) {
      const response = await this.getBackofficeCadastroMedicoStore.backofficeAlterarMedico(this.readonly)

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Médico alterado com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getBackofficeCadastroMedicoStore.getAllCadastrosMedicosByUsuarioHospital(this.getBackofficeCadastroMedicoStore.paginationMedicosCadastrados)
        this.showModalAlterarMedico = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar o médico ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingAlterarMedico = false
  }

  @Watch('showModalAlterarMedico')
  onChangeShowModalAlterarMedico(value: boolean) {
    if (!value) {
      this.getBackofficeCadastroMedicoStore.clearMedicoCadastrado()
      this.cpfErrors = []
      this.firstCPF = ''
      this.getBackofficeCadastroMedicoStore.medicoCadastrado.cboIds = []

      if (this.getBackofficeCadastroMedicoStore.medicoReadonly) {
        this.getBackofficeCadastroMedicoStore.setMedicoReadonly(false)
      }

      if (this.getBackofficeCadastroMedicoStore.ehAlteracaoDeStatus) {
        this.getBackofficeCadastroMedicoStore.setEhAlteracaoDeStatus(false)
      }
    }
  }
}
